// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Clock from "@insite/mobius/Icons/Clock";
import { searchHistoryStyles } from "@west/Overrides/Widgets/Header/SearchHistory";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

searchHistoryStyles.headerText = {
    weight: "bold",
    size: 12,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        text-align: left;
    `,
};

searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 16px;
    `,
};

searchHistoryStyles.itemWrapper = {
    css: css`
        display: flex;
        align-items: center;
        &:not(:last-child) {
            margin-bottom: 14px;
        }
    `,
};

searchHistoryStyles.icon = {
    src: Clock,
    size: 12,
    color: "primary",
    css: css`
        margin-right: 6px;
    `,
};

searchHistoryStyles.link = {
    typographyProps: {
        ellipsis: true,
        size: 12,
        css: css`
            width: 100%;
            text-align: left;
            line-height: 14px;
        `,
    },
    css: css`
        overflow: hidden;
    `,
};

searchHistoryStyles.focusedLink = {
    typographyProps: {
        ellipsis: true,
        css: css`
            width: 100%;
            text-align: left;
        `,
    },
    css: css`
        overflow: hidden;
        background-color: ${color("common.border")};
    `,
};

searchHistoryStyles.clearLink = {
    color: "primary.main",
    typographyProps: {
        size: 12,
        weight: "bold",
        css: css`
            text-align: left;
            letter-spacing: 0;
            line-height: 13px;
        `,
    },
};

searchHistoryStyles.titleWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 12px;
    `,
};
